"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.armundiaInit = armundiaInit;
exports.opt = opt;
exports.isAuth = isAuth;
exports.i18n = i18n;
exports.domain = domain;
exports.domainVal = domainVal;
exports.domainInfoVal = domainInfoVal;
exports.mapInfoVal = mapInfoVal;
exports.setLocale = setLocale;
exports.getLocale = getLocale;

require("moment/locale/hr");

require("moment/locale/hu");

require("moment/locale/sl");

require("moment/locale/sk");

require("moment/locale/it");

require("moment/locale/en-gb");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var authorizations = null;
var domini = null;
var i18nlabels = null;
var opzioni = null;
var locale = "en";
var unsubscribe = null;
var store = null;
var pushActions = null;
var MAXLENGTHPARAMS = 255;
var PARAM_TOKENS_DELIMITER = "#";
/**
 * @param {String} sezione The SEZIONE from AP_OPZIONI
 * @param {Stirng} opzione The OPZIONE from AP_OPZIONI
 * @param {String} defaultValue If the opzione defined from the parameters is not found it is used this value
 * @returns {Ap_Opzioni} Opzione defined by the parameters
 */

function opt(sezione, opzione, defaultValue) {
  if (!opzioni) return null;
  var keyOpzione = sezione + '_' + opzione;
  var opzioneObj = opzioni[keyOpzione];

  if (opzioneObj) {
    return opzioneObj.valore;
  } else if (defaultValue) return defaultValue;else return null;
}
/**
 * @param {String} authid The AUTH_ID that a signed user in the application should have
 * @returns {boolean} 'True' if the user is authorized with the authorization passed
 */


function isAuth(authid) {
  if (!authorizations) {
    return false;
  }

  return authorizations[authid] !== null && authorizations[authid] !== undefined;
}
/**
 * @param {String} labelCode The CODE from AP_LANG
 * @param {String} labelDefault If the label defined from the parameters is not found it is used this value
 * @param  {...any} params E' per tutti quei testi che, una volta tradotti in base al linguaggio corrente 
 * dell'applicazione hanno bisogno di vedere valorizzati determinati valori come codiciStrumento, 
 * descrizione, etc. Es:
 * mex = "(#COD_STRUM#) #DES_SHORT# : Nota report conflitto interesse assente."
 * la stringa mex viene processata con i params che, uno alla volta, sostituiranno le stringhe #VALORE# con
 * i valori desiderati (notazione posizionale)
 * @returns {String} The translated value of the given label code into the session language
 */


function i18n(labelCode, labelDefault) {
  var mex; //modifica 25/10/2019, gestione lunghezza massima labelCode a 20

  var maxLength = 200; // vedi campo AP_LANG.CODE

  if (labelCode.length > maxLength) {
    labelCode = labelCode.substr(0, maxLength - 3) + '...';
  }

  if (!i18nlabels || !i18nlabels[labelCode]) {
    // Label non trovata ... restituisco il "default"
    // marchiato con un "*" e gulp lancio il PUSH
    // della coppia codice, defaultvalue sul server.
    // Il server salverà il messaggio nella lingua
    // attualmente configurata e lo marchierà con un "*"
    // o altro carattere speciale.
    var pushLabelMancanti = opt('I18N', 'PUSH_LABEL_MANCANTI', false);

    if (store && pushLabelMancanti) {
      store.dispatch(pushActions(labelCode, labelDefault));
    } // return labelDefault + " *";
    // c.rosati commmentato in quanto genera molti warning sulla console che rallentano.
    // if (store) {
    //       store.dispatch({
    //             type: "LOAD_I18N", result: {
    //                   labelCode: labelCode,
    //                   labelDefault: labelDefault,
    //             }
    //       });
    // }


    mex = labelDefault;
    var evidenziaLabelMancanti = opt('I18N', 'EVIDENZIA_LABEL_MANCANTI', false);

    if (evidenziaLabelMancanti === 'TRUE') {
      mex = mex + "*";
    }
  } else {
    mex = i18nlabels[labelCode];
    var evidenziaI18n = opt('I18N', 'EVIDENZIA_I18N', false);

    if (evidenziaI18n === 'TRUE') {
      mex = mex + "#";
    }
  }

  for (var _len = arguments.length, params = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    params[_key - 2] = arguments[_key];
  }

  if (params && mex) {
    // params = populateParametri(params);
    // let parametri = params.split(PARAM_TOKENS_DELIMITER);
    var parametri = params;

    for (var i = 0; i < parametri.length; i += 2) {
      var parametro = parametri[i];
      var valore = void 0;

      if (i < parametri.length - 1) {
        valore = parametri[i + 1];
      } else {
        valore = "[null]";
      }

      if (valore) {
        valore = String(valore);
      } else {
        valore = "[null]";
      }

      var currP = PARAM_TOKENS_DELIMITER + parametro + PARAM_TOKENS_DELIMITER;

      while (mex.indexOf(currP) > -1) {
        mex = mex.replace(currP, valore);
      }
    }
  }

  return mex;
}
/**
 * funziona tradotta da flex ma non ancora utilizzata 
 * @deprecated
 * @param {*} parametri 
 */


function populateParametri(parametri) {
  var params;

  for (var i = 0; i < parametri.length; i += 2) {
    if (params) {
      params = params + PARAM_TOKENS_DELIMITER;
    } else {
      params = "";
    } // salta se non esiste il parametro


    if (!parametri[i]) continue;
    var parametro = parametri[i].toString();
    var valore = " *null* ";
    var val = void 0;

    if (parametri[i + 1]) {
      val = parametri[i + 1];
    } else {
      val = " *null* ";
    } // if (val is int) {
    //       var num: Number = new Number(val);
    //       valore = num.toFixed(0);
    // } else
    //       valore = val.toString();


    valore = val;

    if (params.length + parametro.length + valore.length + 1 < MAXLENGTHPARAMS) {
      params = params + parametro + PARAM_TOKENS_DELIMITER + valore;
    }
  }

  return params;
}
/**
 * @param {String} codCampo The COD_CAMPO from AP_DOM
 * @returns {Array} All the domains from the given codCampo
 */


function domain(codCampo) {
  if (!domini) {
    return null;
  } //.valori[param.tipoParam].desDom


  if (!domini[codCampo]) {
    return null;
  }

  if (domini[codCampo].listValori) {
    return domini[codCampo].listValori;
  }

  console.log("function domanin " + codCampo); //per ottimizzare lo spazio occupato sullo store invece di restituire 2 liste per ogni dominio ne restituisco solo una
  //restituisco una Mappa di valori
  //Rutigliano 15/05/2019 converto la mappa in una lista 

  var items = domini[codCampo].valori;
  var keys = Object.getOwnPropertyNames(items);
  var risultato = [];

  var _iterator = _createForOfIteratorHelper(keys),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var key = _step.value;
      console.log("key [" + key + "]"); //ciclo le keys per recuperare gli ogetti della mappa ...

      var obj = items[key];
      var item = {};
      item.valCampo = obj.valCampo;
      item.desDom = obj.desDom;
      item.codCampo = obj.codCampo;
      item.info = obj.info;
      risultato.push(item);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  console.log("restituisco la lista ....");
  return risultato;
}
/**
 * @param {String} codCampo The COD_CAMPO from AP_DOM
 * @param {String} valCampo The VAL_CAMPO from AP_DOM
 * @param {String} defaultvalue If the domain defined from the parameters is not found it is used this value
 * @returns {ApDom} The selected domain from the codCampo and valCampo passed
 */


function domainVal(codCampo, valCampo, defaultvalue) {
  if (!domini || !domini[codCampo]) {
    return defaultvalue ? {
      desDom: defaultvalue
    } : null;
  }

  var dom = domini[codCampo].valori[valCampo];

  if (dom) {
    return dom;
  }

  return {
    desDom: defaultvalue
  };
}
/**
 * 
 * @param {String} codCampo The COD_CAMPO from AP_DOM
 * @param {String} valCampo The VAL_CAMPO from AP_DOM
 * @param {String} nameInfo 
 */


function domainInfoVal(codCampo, valCampo, nameInfo) {
  var domainInfo = domainVal(codCampo, valCampo).info; //return this.valoreInfoSuDominio(domainInfo, nomeInfo);

  var valoreInfo = stringInfoVal(domainInfo, nameInfo);
  return valoreInfo;
}
/**
 * 
 * @param {String} domainInfo 
 */


function mapInfoVal(domainInfo) {
  console.log("mapInfoVal [nomeInfo] " + domainInfo);
  var mappaValori = {};

  if (domainInfo !== undefined && domainInfo !== null) {
    //split su info e prendo il valore del nome info passato
    //esempio valore: PROMO_CORPORATE:TRUE;PRIORITY:H;DAYS_TODEADLINE:5;RECIPIENT_TYPE:PER;
    var res = domainInfo.split(";");

    for (var i = 0; i < res.length; i++) {
      var currInfo = res[i]; //es.PROMO_CORPORATE:TRUE

      var currInfoSplit = currInfo.split(":");
      var currNomeInfo = currInfoSplit[0];
      var currValoreInfo = currInfoSplit[1];
      mappaValori[currNomeInfo] = currValoreInfo;
    }
  }

  return mappaValori;
}
/**
 * 
 * @param {String} domainInfo 
 * @param {String} nameInfo 
 */


function stringInfoVal(domainInfo, nameInfo) {
  console.log("stringInfoVal [nomeInfo] " + nameInfo);
  var valore = '';

  if (domainInfo !== undefined && domainInfo !== null) {
    //split su info e prendo il valore del nome info passato
    //esempio valore: PROMO_CORPORATE:TRUE;PRIORITY:H;DAYS_TODEADLINE:5;RECIPIENT_TYPE:PER;
    var res = domainInfo.split(";");

    for (var i = 0; i < res.length; i++) {
      var currInfo = res[i]; //es.PROMO_CORPORATE:TRUE

      var currInfoSplit = currInfo.split(":");
      var currNomeInfo = currInfoSplit[0];
      var currValoreInfo = currInfoSplit[1];

      if (nameInfo === currNomeInfo) {
        valore = currValoreInfo;
      }
    }
  }

  return valore;
}
/**
 * 
 * @param {String} newLocale example: 'IT-it'
 */


function setLocale(newLocale) {
  if (newLocale !== null && newLocale !== undefined) {
    locale = newLocale;
  }
}
/**
 * @returns {locale} global
 */


function getLocale() {
  return locale;
}

function selectDomini(state) {
  return state.app.domini;
}

function selectAuth(state) {
  return state.app.authorizations;
}

function selectI18N(state) {
  return state.app.i18nlabels;
}

function selectOpzioni(state) {
  return state.app.opzioni;
}

function handleChange() {
  if (domini !== selectDomini(store.getState())) {
    console.log('DOMINI CHANGED');
    domini = selectDomini(store.getState());
  }

  if (authorizations !== selectAuth(store.getState())) {
    console.log('AUTORIZZAZIONI CHANGED');
    authorizations = selectAuth(store.getState());
  }

  if (i18nlabels !== selectI18N(store.getState())) {
    console.log('I18N LABELS CHANGED');
    i18nlabels = selectI18N(store.getState());
  }

  if (opzioni !== selectOpzioni(store.getState())) {
    console.log('OPZIONI CHANGED');
    opzioni = selectOpzioni(store.getState());
  }
}
/**
 * Function to initialize all the actions and stores connected with Redux
 * @param {*} auxStore The store of Redux to be considered
 * @param {*} auxActions All the actions that should be passed
 */


function armundiaInit(auxStore, auxActions) {
  console.log('INIT ARMUNDIA - ADD STORE LISTENER FOR DOMINI, AUTH, I18N');
  store = auxStore;
  pushActions = auxActions;
  unsubscribe = store.subscribe(handleChange);
}